import React from 'react';
import PrimaryButton from './PrimaryButton';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import TuneIcon from '@mui/icons-material/Tune';
import AirIcon from '@mui/icons-material/Air';
import HvacIcon from '@mui/icons-material/Hvac';

const getServiceIcon = (title) => {
  if (title.includes('AC') || title.includes('Cooling')) {
    return <AcUnitIcon fontSize="small" />;
  }

  if (title.includes('Furnace') || title.includes('Heating')) {
    return <WhatshotIcon fontSize="small" />;
  }

  if (title.includes('Installation')) {
    return <BuildCircleIcon fontSize="small" />;
  }

  if (title.includes('Maintenance')) {
    return <TuneIcon fontSize="small" />;
  }

  if (title.includes('Air Quality')) {
    return <AirIcon fontSize="small" />;
  }

  return <HvacIcon fontSize="small" />;
};

const ServiceCard = ({ slug, title, description }) => (
  <article className="card service-card">
    <div className="service-card-icon" aria-hidden="true">
      {getServiceIcon(title)}
    </div>

    <h3>{title}</h3>
    <p>{description}</p>

    <div className="service-card-action">
      <PrimaryButton to={`/service/${slug}`}>View {title}</PrimaryButton>
    </div>
  </article>
);

export default ServiceCard;
